// extracted by mini-css-extract-plugin
export default {"indentation":"s32IG","summary-group":"gaTOJ","summaryGroup":"gaTOJ"};